import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Button, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import swal from "sweetalert";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import BASE_URL from "../../../assets/global/url";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import { useExpensePDF, ExpensePDFFrame } from "../PdfExpenses/PDFExpenses";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import { format } from "date-fns";
import CustomDatePicker from "../../../components/CustomDatePicker";
import TypedDateInput from "../../../components/inputs/TypedDateInput";
import useFormattedNumberInput from "../../../hooks/customHook/Number_Formatter";
import { parseNumber } from "../../../utils/numberFormatter";
import { checkCutoffDate } from "../../../utils/cutoffDateValidation";

// Compares two dates by calendar day only (ignores time-of-day), so a
// plain date string and a Date object produced by the picker still
// compare correctly even when their internal times differ.
const toDateOnly = (value) => {
  const d = new Date(value);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

const AddExpenses = ({ authrztn }) => {
  const userLoggedID = useDecodeToken();
  const navigate = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [validated, setValidated] = useState(false);
  const [transaction_id, setTransaction_id] = useState("");
  const [clientTransactionId, setClientTransactionId] = useState("");
  const [expensesType_db, setExpensesType_db] = useState([]);
  // const [totalAmount, setTotalAmount] = useState("");
  const [totalAmountDisplay, handleTotalAmountChange, setTotalAmountValue] =
    useFormattedNumberInput("");
  const [integer = "", decimal = ""] = totalAmountDisplay.split(".");
  const [desc, setDesc] = useState("");
  const [expenses_date, setExpenses_date] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [currency_db, setCurrency_db] = useState([]);
  const [foreign, setForeign] = useState("Local");
  const [expensesSubType_id, setExpensesSubType_id] = useState();
  const [expenseTypeOneId, setExpenseTypeOneId] = useState("");
  const [expensesType_name, setExpensesType_name] = useState("");
  const [selected_currency_id, setSelected_currency_id] = useState();

  const [productName, setProductName] = useState("");
  const [currencyRate, setCurrencyRate] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [assetQuantity, setAssetQuantity] = useState("");
  const [status, setStatus] = useState("");
  const [edit, setEdit] = useState(false);
  const [isCutoffPosted, setIsCutoffPosted] = useState(false);
  const [isCutoffExists, setIsCutoffExists] = useState(true);
  const [isAdded, setIsAdded] = useState(false);
  const [isCurrencyDisabled, setIsCurrencyDisabled] = useState(false);
  const [editableCurrencyRate, setEditableCurrencyRate] =
    useState(currencyRate);

  const [print, setPrint] = useState(false);
  // Generated once each time the PDF modal opens, shared by viewer and download
  const expensePdf = useExpensePDF(id, print);
  ///New Added for updated
  //START
  const [userList, setUserList] = useState([]);
  const [accountable, setAccountable] = useState(null);
  const [accountables, setAccountables] = useState(null);

  const [expensesCheque, setExpensesCheque] = useState(""); // para sa yilujia kasi un ang pag babasihan nila

  const [isExternalAccountable, setIsExternalAccountable] = useState(false);
  const [externalAccountableText, setExternalAccountableText] = useState("");
  ///END
  // const fetchLastCode = () => {
  //   axios
  //     .get(BASE_URL + "/expenses/getCode")
  //     .then((res) => {
  //       setTransaction_id(res.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const fetchExpenses = async () => {
    await axios
      .get(BASE_URL + "/expenses2/fetchTable", {
        params: {
          expenseTypeOneId,
          expenseTypeTwoId: expensesSubType_id?.value,
        },
      })
      .then((response) => {
        setExpensesType_db(response.data);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  };
  //START FETCH ALL
  const fetchUsers = async () => {
    await axios
      .get(BASE_URL + "/masterList/fetchAllUsers")
      .then((response) => {
        console.warn("fetchAllUsers response:", response.data); // DEBUG
        setUserList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  };
  //END

  const handleAmountBlur = (e) => {
    // Only format if the field is editable
    if (!edit) return;

    // Strip existing commas to prevent NaN errors
    const rawValue = String(e.target.value).replace(/,/g, "");

    if (rawValue && !isNaN(rawValue)) {
      // Force exactly two decimal places
      const formattedValue = parseFloat(rawValue).toFixed(2);

      // Pass the formatted value back to the hook using a synthetic event
      handleTotalAmountChange({ target: { value: formattedValue } });
    }
  };

  const fetchCurrency = async () => {
    await axios
      .get(BASE_URL + "/currency/fetchCurrency")
      .then((response) => {
        setCurrency_db(response.data);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  };

  const reloadDataExpenses = async () => {
    axios
      .get(`${BASE_URL}/expenses/fetch_data_update`, {
        params: {
          id,
        },
      })
      .then((res) => {
        setTransaction_id(res.data.transaction_id);
        setClientTransactionId(res.data.client_transaction_id);
        setSelected_currency_id(res.data.currency_id);
        setProductName(res.data.product_name);
        setUnitPrice(res.data.unitPrice);
        setAssetQuantity(res.data.assetQuantity);
        // setTotalAmount(res.data.totalAmount);
        setTotalAmountValue(
          res.data.totalAmount != null
            ? parseFloat(res.data.totalAmount).toFixed(2)
            : "",
        );
        setExpenses_date(res.data.expenses_date);
        setDueDate(res.data.due_date);
        setDesc(res.data.desc);
        setExpensesSubType_id({
          value: res.data.expenses2_id.toString(),
          label: `${res.data.expenses2.expenses_one.expenses_type_one} - ${res.data.expenses2.sub_type}`,
        });
        setExpenseTypeOneId(res.data.expenses2.expenses_one.expenses_one_id);
        setExpensesType_name(res.data.expenses2.sub_type);
        setForeign(res.data.foreign);
        setStatus(res.data.status);
        setIsCutoffPosted(res.data.isPosted);
        setIsCutoffExists(res.data.cutoffExists);
        setIsAdded(!!res.data.isAdded);
        setCurrencyRate(res.data.rate);
        setIsCurrencyDisabled(res.data.existInFixedAsset);
        setAccountables(res.data.accountable); // ADDED
        setExpensesCheque(res.data.expensesCheque); // para sa yilujia kasi un ang pag babasihan nila
        setIsExternalAccountable(res.data.isExternalAccountable);
        setExternalAccountableText(res.data.externalAccountable);
      });
  };

  const handleExpensesChange = (selectedOption) => {
    const selectedId = selectedOption?.value;
    setExpensesSubType_id(selectedOption);

    setProductName("");
    setUnitPrice("");
    setAssetQuantity("");

    const selected = expensesType_db.find(
      (data) => String(data.id) === String(selectedId, 10), // ADDED
    );
    if (selected) {
      setExpensesType_name(selected.sub_type);
    } else {
      setExpensesType_name("");
    }
  };

  //START FOR ACCOUNTABLE ID FILTER/DISPLAY FROM ACCOUNTABLE
  useEffect(() => {
    if (accountables && userList.length > 0) {
      const user = userList.find((u) => u.id === accountables);
      if (user) {
        setAccountable({
          value: user.id,
          label: `${user.fname} ${user.mname ? user.mname + " " : ""}${
            user.lname
          }`,
        });
      }
    }
  }, [accountables, userList]);
  //END

  const onInputFloat = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  const add = async (e) => {
    //save buttonm
    e.preventDefault();
    const form = e.currentTarget;

    // let formatTotalAmount = String(totalAmount).replace(/,/g, "");
    let formatTotalAmount = String(totalAmountDisplay).replace(/,/g, "");
    let formatUnitPrice = String(unitPrice).replace(/,/g, "");
    let formatAsset = String(assetQuantity).replace(/,/g, "");

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else if (
      expenses_date &&
      dueDate &&
      toDateOnly(expenses_date) > toDateOnly(dueDate)
    ) {
      swal({
        icon: "error",
        title: "Invalid Date",
        text: "Expenses Date cannot be later than Due Date.",
      });
    } else {
      swal({
        title: "Update this expenses?",
        text: "Please confirm to update this expenses",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          axios
            .post(`${BASE_URL}/expenses/updateExpenses`, {
              id,
              totalAmount: parseFloat(formatTotalAmount),
              desc,
              expenses_date,
              dueDate,
              expensesSubType_id: expensesSubType_id?.value,
              transaction_id,
              clientTransactionId,
              foreign,
              selected_currency_id,
              productName,
              unitPrice: parseFloat(formatUnitPrice),
              assetQuantity: parseFloat(formatAsset),
              currencyRate: editableCurrencyRate,
              userLoggedID,
              accountable: !isExternalAccountable
                ? (accountable?.value ?? null)
                : null,
              expensesCheque, // para sa yilujia kasi un ang pag babasihan nila
              isExternalAccountable,
              externalAccountableText: isExternalAccountable
                ? externalAccountableText
                : null,
            })
            .then((res) => {
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Expenses updated successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  reloadDataExpenses();
                  setEdit(false);
                });
              } else if (res.status === 201) {
                swal({
                  title: "Opppss!",
                  text: "Cutoff already posted for this date",
                  icon: "warning",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              } else if (res.status === 203) {
                swal({
                  title: "Opppss!",
                  text: "This expense is already included in a bulk payment and can no longer be edited.",
                  icon: "warning",
                  buttons: false,
                  timer: 2500,
                  dangerMode: true,
                }).then(() => {
                  reloadDataExpenses();
                });
              } else {
                swal({
                  title: "Something Went Wrong",
                  text: "Please contact your support immediately",
                  icon: "error",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              }
            })
            .catch((err) => {
              if (err.response && err.response.status === 409) {
                swal({
                  icon: "error",
                  title: "Transaction ID Conflict",
                  text: "The transaction ID you entered already exists in the system. Please use a unique identifier.",
                });
                return;
              }
            });
        }
      });
    }
    setValidated(true);
  };

  // useEffect(() => {
  //   // fetchLastCode();
  //   fetchUsers(); ///NEW ADDED
  //   fetchCurrency();
  //   reloadDataExpenses();
  // }, []);

  useEffect(() => {
    const load = async () => {
      await fetchUsers();
      await fetchCurrency();
      await reloadDataExpenses();
    };

    load();
  }, []);

  useEffect(() => {
    fetchExpenses();
  }, [expenseTypeOneId]);

  const handleApprove = () => {
    swal({
      title: "Approve this request?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        // For expense journal
        const currency = currency_db.find((c) => c.id === selected_currency_id);
        const currencyName = currency?.currency_name;
        const currencyRate = currency?.currency_rate;

        try {
          axios
            .post(
              `${BASE_URL}/expenses/approved`,
              {
                expenseJournal: {
                  expenses2Id: expensesSubType_id?.value,
                  date: expenses_date,
                  // totalAmount,
                  totalAmount: parseFloat(
                    String(totalAmountDisplay).replace(/,/g, ""),
                  ),
                  paymentType: "Debit",
                  currencyName,
                  currencyRate,
                  transaction_number: transaction_id,
                },
              }, // req.body
              {
                params: {
                  id,
                  userLoggedID,
                },
              }, // req.query
            )
            .then((res) => {
              if (res.status === 201) {
                swal({
                  title: "Oppss!",
                  text: "Insufficient balance",
                  icon: "error",
                  dangerMode: true,
                });
              } else if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Successfully approved this request",
                  icon: "success",
                  timer: 2000,
                }).then(() => {
                  // navigate(
                  //   `/accounting/expenses?page=${searchParams.get("page")}`
                  // );
                  reloadDataExpenses();
                });
              } else {
                swal({
                  title: "Something went wrong",
                  text: "Please contact your support immediately",
                  icon: "warning",
                  buttons: true,
                  dangerMode: true,
                });
              }
            });
        } catch (error) {
          console.log(error);
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          });
        }
      }
    });
  };

  const handleReject = () => {
    swal({
      title: "Reject this request?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        try {
          axios
            .post(`${BASE_URL}/expenses/rejected`, null, {
              params: {
                id,
                userLoggedID,
                transaction_number: transaction_id,
              },
            })
            .then((res) => {
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Successfully rejected this request",
                  icon: "success",

                  dangerMode: true,
                }).then(() => {
                  // navigate(
                  //   `/accounting/expenses?page=${searchParams.get("page")}`
                  // );
                  reloadDataExpenses();
                });
              } else {
                swal({
                  title: "Something went wrong",
                  text: "Please contact your support immediately",
                  icon: "warning",
                  buttons: true,
                  dangerMode: true,
                });
              }
              // setExpensesData(res.data);
              // console.log(res.data);
            });
        } catch (error) {
          console.log(error);
          swal({
            title: "Something went wrong",
            text: "Please contact your support immediately",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          });
        }
      }
    });
  };

  const dateValidation = async (selectedDate, clearField, dateLabel) => {
    try {
      const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
        params: {
          date: selectedDate,
        },
      });
      // if (res.data == false) {
      //   swal({
      //     icon: "error",
      //     title: `Invalid ${dateLabel}`,
      //     text: `Please Create Cutoff for this Date (${format(
      //       selectedDate,
      //       "MMM/dd/yyyy"
      //     )})`,
      //     // buttons: false,
      //     // timer: 2000,
      //   }).then(() => {
      //     clearField("");
      //   });
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const dueDateValidation = async (selectedDueDate, clearField) => {
    try {
      const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
        params: {
          date: selectedDueDate,
        },
      });
      // if (res.data == false) {
      //   swal({
      //     icon: "error",
      //     title: "Invalid Due Date Selection",
      //     text: "Please Create Cutoff for this Date",
      //   }).then(() => {
      //     clearField("");
      //   });
      // }
    } catch (error) {
      console.error(error);
    }
  };
  // NEW ADDED FOR OPTIONS
  const userOptions = userList.map((user) => ({
    value: user.id,
    label: `${user.fname} ${user.mname ? user.mname + " " : ""}${user.lname}`,
  }));
  // NEW ADDED

  //   const handleAmountValue = (value) => {
  //   if (value == ".") {
  //     setTotalAmount((prev) => prev + ".");
  //   }

  //   let inputValue = String(value).replace(/[^0-9.]/g, "");

  //   let [integerPart, decimalPart] = inputValue.split(".");

  //   if (integerPart) {
  //     integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }
  //   let formattedValue =
  //     decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

  //   setTotalAmount(formattedValue);
  // };

  const handleSetUnitPriceValue = (value) => {
    if (value == ".") {
      setUnitPrice((prev) => prev + ".");
    }

    let inputValue = String(value).replace(/[^0-9.]/g, "");

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setUnitPrice(formattedValue);
  };

  const handleChangeCurrency = (value) => {
    const curr = currency_db.find((data) => String(data.id) === String(value));
    setSelected_currency_id(curr.id);
    if (!edit) {
      setCurrencyRate(curr.currency_rate);
      setEditableCurrencyRate(curr.currency_rate);
    }
  };

  const openPDFPreview = () => {
    // window.open(`/invoice-pdf-view?id=${id}`, "_blank");
    setPrint(true);
  };

  // Expense Type 1 Options for dropdown select
  const expenseType1Options = expensesType_db.map((item) => ({
    value: item.id,
    label: `${item.expenses_one.expenses_type_one} - ${item.sub_type}`,
  }));

  // Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
  // (TypedDateInput), or picked from the calendar. Wrapped in useMemo so the
  // input isn't remounted on every render; only re-created when `edit` toggles,
  // so `disabled` always follows the edit mode. Only a complete date reaches
  // handleDateChange, so the cutoff check doesn't run on a half-typed date.
  const CustomInput = useMemo(() => {
    const Input = React.forwardRef(
      (
        { value, onClick, onChange, onBlur, onFocus, onKeyDown, generateYears },
        ref,
      ) => {
        return (
          <TypedDateInput
            className="form-control p-3 w-100"
            style={{ cursor: edit ? "text" : "pointer" }}
            onClick={(e) => {
              if (onClick) onClick(e);

              let selectedYear = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                // Extract year safely if value is a valid date
                if (!isNaN(parsed.getTime())) {
                  selectedYear = parsed.getFullYear();
                }
              }

              // Reset/Initialize Year List based on selected date
              if (generateYears && typeof generateYears === "function") {
                generateYears(selectedYear);
              }
            }}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            value={value}
            ref={ref}
            required
            disabled={!edit}
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, [edit]);

  //   useEffect to sync the currency rate when it changes, around line 125
  useEffect(() => {
    if (currencyRate !== undefined && currencyRate !== null) {
      setEditableCurrencyRate(currencyRate);
    }
  }, [currencyRate]);

  //  function to handle currency rate changes, around line 135
  const handleEditableCurrencyRateChange = (e) => {
    const value = e.target.value;
    let inputValue = value.replace(/[^0-9.]/g, "");

    // Prevent multiple decimal points
    const decimalCount = (inputValue.match(/\./g) || []).length;
    if (decimalCount <= 1) {
      if (inputValue) {
        inputValue = inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      const cleanedValue = inputValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma
      setEditableCurrencyRate(value.length > 1 ? cleanedValue : inputValue);
      setCurrencyRate(value.length > 1 ? cleanedValue : inputValue);
    }
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="w-100 p-2 d-flex flex-row justify-content-between align-items-center">
        <div className="d-flex align-items-center title-custom">
          <span className="fs-3">
            <Link to="/accounting/expenses" className="text-dark me-2">
              <i className="fa-solid fa-arrow-left"></i>
            </Link>
            EXPENSES DETAILS
          </span>
        </div>

        {/* Button on the right */}
        {authrztn.includes("Expenses-Print") && status !== "For-Approval" && (
          <div>
            <button
              className="btn btn-outline-danger"
              type="button"
              onClick={openPDFPreview}
            >
              Preview PDF
            </button>
          </div>
        )}
      </div>

      <Form noValidate validated={validated} onSubmit={add}>
        <div className="col-sm">
          <Form.Group className="mb-3" controlId="payWith">
            <Form.Label className="fw-bold">Foreign Type :</Form.Label>
            <div className="d-flex">
              <Form.Check
                type="radio"
                name=""
                id="Local"
                label="Local"
                value="Local"
                disabled={!edit}
                checked={foreign === "Local"}
                onClick={(e) => {
                  setForeign(e.target.value);
                }}
                className="me-3"
              />
              <Form.Check
                type="radio"
                name=""
                id="Overseas"
                label="Overseas"
                value="Overseas"
                disabled={!edit}
                checked={foreign === "Overseas"}
                onClick={(e) => {
                  setForeign(e.target.value);
                }}
                className="me-3"
              />
            </div>
          </Form.Group>
        </div>
        <div className="container-fluid mt-4 p-0">
          <div className="row mx-auto">
            <div className="d-none col-sm">
              <span>Transaction ID :</span>
              <div className="input-group mb-2">
                <input
                  type="text"
                  required
                  value={transaction_id}
                  readOnly
                  className="form-control p-3"
                  id="inlineFormInputGroup"
                />
              </div>
            </div>
            <div className="col-sm">
              <span>Transaction ID :</span>
              <div className="input-group mb-2">
                {/* Display only - generated by the server on create */}
                <input
                  type="text"
                  value={clientTransactionId}
                  readOnly
                  className="form-control p-3"
                  id="client-transaction-id"
                />
              </div>
            </div>
            <div className="col-sm">
              <div className="d-flex align-items-center mb-2">
                <span className="me-3 ">ACCOUNTABLE</span>

                <div className="form-check mb-0 text-muted badge ">
                  <label
                    className="form-check-label ms-1 "
                    htmlFor="externalAccountable"
                  >
                    External Accountable Person
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="externalAccountable"
                    checked={isExternalAccountable}
                    onChange={(e) => {
                      setIsExternalAccountable(e.target.checked);
                      // setAccountable(null);
                      // setExternalAccountableText("");
                    }}
                    disabled={!edit}
                  />
                </div>
              </div>
              <div className="mb-2">
                {isExternalAccountable ? (
                  <input
                    type="text"
                    required
                    value={externalAccountableText}
                    onChange={(e) => setExternalAccountableText(e.target.value)}
                    className="form-control p-3"
                    readOnly={!edit}
                  />
                ) : (
                  <Select
                    options={userOptions}
                    value={accountable}
                    onChange={(selected) => setAccountable(selected)}
                    placeholder="Select Accountable Person"
                    styles={selectCustomStyles(
                      accountable ?? "optional",
                      validated,
                      "0.55rem",
                    )}
                    ///styles={selectCustomStyles(accountable, validated ? true : false, "0.55rem")}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isDisabled={!edit}
                  />
                )}
              </div>
              {/* END */}
            </div>
          </div>
          <div className="row mx-auto">
            <React.Fragment>
              <div className="col-sm mb-2">
                <span>Expenses Type 1</span>
                {/* <select
                  required
                  onChange={handleExpensesChange}
                  className="form-select p-3"
                  value={expensesSubType_id}
                  disabled={!edit}
                >
                  <option value="" selected disabled>
                    Select Expense Type
                  </option>
                  {expensesType_db.map((data) => (
                    <option key={data.id} value={data.id}>
                      {`${data.expenses_one.expenses_type_one} - ${data.sub_type}`}
                    </option>
                  ))}
                </select> */}
                <Select
                  options={expenseType1Options}
                  value={expensesSubType_id}
                  onChange={handleExpensesChange}
                  placeholder={`Select Expense Type 1`}
                  styles={selectCustomStyles(
                    expensesSubType_id,
                    validated,
                    "0.55rem",
                  )}
                  isDisabled={!edit}
                  required
                />
              </div>

              <div className="col-sm mb-2">
                <span>Expenses Type 2</span>
                <input
                  type="text"
                  required
                  readOnly
                  value={expensesType_name}
                  className="form-control p-3"
                  id="inlineFormInputGroup"
                />
              </div>
            </React.Fragment>
          </div>

          {/* {expensesSubType_id === "6614fb23-2cfb-434e-901a-3f06d6ebc54f" && (
            <div className="row mx-auto mt-3">
              <div className="col-sm mb-2">
                <span>Product Name</span>
                <input
                  type="text"
                  value={productName}
                  required
                  readOnly={!edit}
                  onChange={(e) => setProductName(e.target.value)}
                  className="form-control p-3"
                  id="inlineFormInputGroup"
                />
              </div>
              <div className="col-sm mb-2">
                <span>Unit Price</span>
                <input
                  type="text"
                  value={unitPrice.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  readOnly={!edit}
                  required
                  onChange={(e) => {
                    handleSetUnitPriceValue(e.target.value);
                    handleAmountValue(e.target.value * assetQuantity);
                  }}
                  onInput={onInputFloat}
                  className="form-control p-3"
                  id="inlineFormInputGroup"
                />
              </div>
              <div className="col-sm mb-2">
                <span>Quantity</span>
                <input
                  type="text"
                  value={assetQuantity.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  readOnly={!edit}
                  required
                  onChange={(e) => {
                    let value = e.target.value;

                    if (value == ".") {
                      setAssetQuantity((prev) => prev + ".");
                    }

                    let inputValue = String(value).replace(/[^0-9.]/g, "");

                    let [integerPart, decimalPart] = inputValue.split(".");

                    if (integerPart) {
                      integerPart = integerPart.replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                      );
                    }

                    let formattedValue =
                      decimalPart !== undefined
                        ? `${integerPart}.${decimalPart}`
                        : integerPart;

                    let formatAmount = parseFloat(inputValue.replace(/,/g, ""));

                    setAssetQuantity(formattedValue);
                    let formatUnitPrice = String(unitPrice).replace(
                      /[^0-9.]/g,
                      ""
                    );
                    handleAmountValue(
                      parseFloat(formatUnitPrice) * formatAmount
                    );
                  }}
                  onInput={onInputFloat}
                  className="form-control p-3"
                  id="inlineFormInputGroup"
                />
              </div>
            </div>
          )} */}

          <div className="row mx-auto mt-3">
            <div className="col-sm">
              <label htmlFor="expenses_date">Expenses Date</label>
              {/* <input
                value={expenses_date}
                readOnly={!edit}
                type="date"
                required
                onChange={(e) => {
                  setExpenses_date(e.target.value);
                  if (e.target.value) {
                    dateValidation(e.target.value, setExpenses_date);
                  }
                }}
                name=""
                id="expenses_date"
                className="form-control py-3 ps-3"
                style={{ paddingRight: `${validated ? "2rem" : "1rem"}` }}
              /> */}
              <CustomDatePicker
                label={"Expenses Date"}
                selected={expenses_date ? new Date(expenses_date) : ""}
                handleDateChange={(date) => {
                  setExpenses_date(date);
                  // Replaced by checkCutoffDate (utils/cutoffDateValidation)
                  // if (date) {
                  //   dateValidation(date, setExpenses_date, "Expenses Date");
                  // }
                  // CustomInput (TypedDateInput) only sends complete dates
                  if (date) checkCutoffDate(date, "Expenses Date");
                }}
                setter={setExpenses_date}
                CustomInput={CustomInput}
                isRequired={true}
                validated={validated}
                // Replaced by checkCutoffDate (utils/cutoffDateValidation)
                // dateValidation={dateValidation}
                dateValidation={(date) => {
                  checkCutoffDate(date, "Expenses Date");
                }}
                iconTopOffset={"1.3rem"}
                maxDate={dueDate ? new Date(dueDate) : undefined}
              />
            </div>

            <div className="col-sm mb-2">
              <label htmlFor="due_date">Due Date</label>
              {/* <input
                value={dueDate}
                readOnly={!edit}
                type="date"
                required
                onChange={(e) => {
                  setDueDate(e.target.value);
                  // if (e.target.value) {
                  //   dueDateValidation(e.target.value, setDueDate);
                  // }
                }}
                name=""
                id="due_date"
                className="form-control py-3 ps-3"
                style={{ paddingRight: `${validated ? "2rem" : "1rem"}` }}
              /> */}
              <CustomDatePicker
                selected={dueDate ? new Date(dueDate) : ""}
                handleDateChange={(date) => {
                  setDueDate(date);
                  if (date) checkCutoffDate(date, "Due Date");
                }}
                setter={setDueDate}
                CustomInput={CustomInput}
                isRequired={true}
                validated={validated}
                dateValidation={(date) => {
                  checkCutoffDate(date, "Due Date");
                }}
                iconTopOffset={"1.3rem"}
                minDate={expenses_date ? new Date(expenses_date) : undefined}
              />
            </div>
          </div>
          <div className="row mx-auto mt-3">
            <div className="col-sm">
              <div className="col-sm mb-2">
                <span>Amount</span>
                {selected_currency_id &&
                selected_currency_id !==
                  "11111111-1111-1111-1111-111111111111" ? (
                  <span className="text-muted mb-1">
                    {" | "}
                    Current Rate: {currencyRate}
                  </span>
                ) : null}
                <div className="input-group mb-2">
                  <div className="input-group-prepend">
                    <div className="input-group-text h-100">
                      <select
                        required
                        onChange={(e) => handleChangeCurrency(e.target.value)}
                        className="form-select"
                        disabled={!edit || isCurrencyDisabled}
                        value={selected_currency_id}
                      >
                        <option value="" selected disabled>
                          Select Currency
                        </option>
                        {currency_db.map((data) => (
                          <option key={data.id} value={data.id}>
                            {`${data.currency_name}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <input
                    type="text"
                    // value={totalAmount?.toLocaleString("en-US", {
                    //   minimumFractionDigits: 2,
                    //   maximumFractionDigits: 2,
                    // })}
                    value={totalAmountDisplay}
                    required
                    readOnly={
                      expensesSubType_id ===
                      "11111111-1111-1111-1111-111111111111"
                        ? true
                        : !edit
                    }
                    // onChange={(e) => handleAmountValue(e.target.value)}
                    // onInput={onInputFloat}
                    onChange={handleTotalAmountChange}
                    onBlur={handleAmountBlur}
                    maxLength={decimal ? 20 : 19}
                    className="form-control p-3 z-0"
                    id="inlineFormInputGroup"
                  />
                </div>
              </div>

              {selected_currency_id !== "" &&
              selected_currency_id !==
                "11111111-1111-1111-1111-111111111111" ? (
                <div className="col-sm mb-2 d-none">
                  <span>
                    Currency Rate <span className="text-danger">*</span>
                  </span>
                  <div className="input-group mb-2">
                    {edit ? (
                      <input
                        type="text"
                        value={editableCurrencyRate}
                        required
                        onChange={handleEditableCurrencyRateChange}
                        className="form-control p-3"
                        id="inlineFormInputGroup"
                        placeholder="Enter Currency Rate"
                        readOnly
                      />
                    ) : (
                      <input
                        type="text"
                        value={parseFloat(currencyRate || 1).toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 4,
                            maximumFractionDigits: 4,
                          },
                        )}
                        readOnly
                        className="form-control p-3"
                        id="inlineFormInputGroup"
                      />
                    )}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="col-sm ">
              <span>Cheque Number :</span>{" "}
              <div className="input-group mb-2">
                <input
                  type="text"
                  readOnly={!edit}
                  value={expensesCheque}
                  onChange={(e) => setExpensesCheque(e.target.value)}
                  className="form-control p-3"
                  id="client-transaction-id"
                />
              </div>
            </div>
            {/* commented kasi nilipat sa baba */}
            {/* <div className="col-sm mb-2">
              <label htmlFor="description">Description</label>
              <Form.Control
                id="remarks"
                as="textarea"
                readOnly={!edit}
                rows={3}
                style={{
                  fontSize: "16px",
                  height: "200px",
                  maxHeight: "200px",
                  resize: "none",
                  overflowY: "auto",
                }}
                placeholder="Enter Description"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />
            </div> */}
          </div>
        </div>

        <div className="row mt-4 mx-auto">
          <div className="col-sm mb-2">
            <label htmlFor="description">Description</label>
            <Form.Control
              id="remarks"
              as="textarea"
              readOnly={!edit}
              rows={3}
              style={{
                fontSize: "16px",
                height: "200px",
                maxHeight: "200px",
                resize: "none",
                overflowY: "auto",
              }}
              placeholder="Enter Description"
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
            />
          </div>
        </div>
        <div className="row mt-4 mx-auto">
          <div className="col-sm"></div>
          <div className="col-sm"></div>
          {status === "For-Approval" ||
          (status === "Approved" &&
            authrztn.includes("Expenses-PostApprovalEdit")) ? (
            <React.Fragment>
              {edit ? (
                <div className="row w-25 me-3">
                  <div className="col-sm text-end">
                    <div className="w-75 ms-auto text-nowrap">
                      <Button
                        variant="outline-secondary"
                        className="mx-3 w-50"
                        type="button"
                        onClick={() => {
                          setEdit(false);
                          reloadDataExpenses();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button className="btn btn-primary w-50" type="submit">
                        Update
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-25 text-end">
                  <div className="d-flex w-100 flex-row">
                    <div
                      className={`d-flex flex-row ${
                        authrztn.includes("Expenses-Approved")
                          ? "w-50"
                          : "w-100"
                      }`}
                    >
                      {status === "For-Approval" &&
                        authrztn.includes("Expenses-Edit") && (
                          <Button
                            variant="outline-primary"
                            className="w-100 me-3"
                            onClick={(e) => {
                              e.preventDefault();
                              setEdit(true);
                            }}
                            type="button"
                          >
                            Edit
                          </Button>
                        )}

                      {/* Post-approval edit: only visible once the record is
                          Approved and the role has the Expenses-PostApprovalEdit
                          permission checked; hidden otherwise (same as before). */}
                      {status === "Approved" &&
                        authrztn.includes("Expenses-PostApprovalEdit") && (
                          <Button
                            variant="outline-primary"
                            className="w-100 me-3"
                            onClick={(e) => {
                              e.preventDefault();
                              setEdit(true);
                            }}
                            type="button"
                            disabled={
                              isCutoffPosted ||
                              !isCutoffExists ||
                              isAdded === true
                            }
                          >
                            Edit
                          </Button>
                        )}
                    </div>

                    {authrztn.includes("Expenses-Approved") && (
                      <div className="flex-grow-1">
                        <button
                          className="btn btn-outline-danger w-100 d-inline-flex align-items-center justify-content-center gap-2"
                          type="button"
                          onClick={openPDFPreview}
                          disabled={isCutoffPosted || !isCutoffExists}
                        >
                          <i className="fa-solid fa-file-pdf"></i>
                          Preview PDF
                        </button>
                      </div>
                    )}

                    {/* Add an additional check for Expenses-Approve BEFORE rendering the buttons */}
                    {authrztn.includes("Expenses-Approved") &&
                      status === "For-Approval" && (
                        <div className="d-none d-flex w-100 flex-row">
                          <Button
                            variant="danger"
                            className="w-50"
                            type="button"
                            onClick={() => {
                              handleReject();
                            }}
                            disabled={isCutoffPosted || !isCutoffExists}
                          >
                            Reject
                          </Button>
                          <Button
                            variant="success"
                            className="ms-3 w-50"
                            type="button"
                            onClick={() => {
                              handleApprove();
                            }}
                            disabled={isCutoffPosted || !isCutoffExists}
                          >
                            Approve
                          </Button>
                        </div>
                      )}
                  </div>
                  {((status === "For-Approval" &&
                    (authrztn.includes("Expenses-Edit") ||
                      authrztn.includes("Expenses-Approved"))) ||
                    (status === "Approved" &&
                      authrztn.includes("Expenses-PostApprovalEdit"))) &&
                    isCutoffPosted && (
                      <div
                        className="w-100 p-0 ms-auto mt-2"
                        style={{ fontSize: "0.8rem" }}
                      >
                        <p className="text-danger">
                          Action is prohibited as the Expenses date has already
                          been posted.
                        </p>
                      </div>
                    )}

                  {((status === "For-Approval" &&
                    (authrztn.includes("Expenses-Edit") ||
                      authrztn.includes("Expenses-Approved"))) ||
                    (status === "Approved" &&
                      authrztn.includes("Expenses-PostApprovalEdit"))) &&
                    !isCutoffExists && (
                      <div
                        className="w-100 p-0 ms-auto mt-2"
                        style={{ fontSize: "0.8rem" }}
                      >
                        <p className="text-danger">
                          Action is prohibited as the Cutoff date has not been
                          created.
                        </p>
                      </div>
                    )}

                  {status === "Approved" &&
                    authrztn.includes("Expenses-PostApprovalEdit") &&
                    isAdded && (
                      <div
                        className="w-100 p-0 ms-auto mt-2"
                        style={{ fontSize: "0.8rem" }}
                      >
                        <p className="text-danger">
                          Action is prohibited as this expense has already been
                          included in a bulk payment.
                        </p>
                      </div>
                    )}
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </div>
      </Form>

      <Modal show={print} size="xl" onHide={() => setPrint(false)}>
        <div className="position-relative">
          <a
            href={expensePdf.url || undefined}
            download={`Expenses - ${transaction_id}.pdf`}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip
                  id="tooltip-right"
                  className="me-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Download as{" "}
                  <strong className="text-danger">
                    "Expenses - {transaction_id}.pdf"
                  </strong>
                </Tooltip>
              }
              delay={300}
            >
              <Button
                variant="light"
                className="position-absolute btn btn-light border border-secondary-subtle mb-5 rounded-5"
                style={{ bottom: "-1.8rem", left: "1rem" }}
                disabled={!expensePdf.url}
              >
                <i class="fa-solid fa-download"></i>
              </Button>
            </OverlayTrigger>
          </a>

          {/* Add an additional check for Expenses-Approve BEFORE rendering the buttons */}
          <div
            className="position-absolute"
            style={{
              bottom: "1.5rem",
              right: "2.5rem",
            }}
          >
            {authrztn.includes("Expenses-Approved") &&
            status === "For-Approval" ? (
              <div className="d-flex gap-1">
                <button
                  className="btn btn-sm btn-danger px-3"
                  type="button"
                  onClick={() => {
                    handleReject();
                  }}
                  disabled={isCutoffPosted || !isCutoffExists}
                >
                  Reject
                </button>
                <button
                  className="btn btn-sm btn-success"
                  type="button"
                  onClick={() => {
                    handleApprove();
                  }}
                  disabled={isCutoffPosted || !isCutoffExists}
                >
                  Approve
                </button>
              </div>
            ) : (
              <span
                className={`badge px-3 py-2 fs-6 ${
                  status === "Approved"
                    ? "bg-success-subtle text-success border border-success-subtle"
                    : "bg-danger-subtle text-danger border border-danger-subtle"
                }`}
              >
                {status}
              </span>
            )}
          </div>
          <ExpensePDFFrame url={expensePdf.url} error={expensePdf.error} />
        </div>
      </Modal>
    </div>
  );
};

export default AddExpenses;
